
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Lib from '@ext/utils'
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: String } )
        public value: string;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;
        }

       

        public Error: boolean = false;

        public selected: string | null = null;
        public get Selected(): string | null {
            return this.selected;
        }
        public set Selected( x: string | null ) {

            if ( x === null || x.length === 0 ) {
                this.selected = '';
                this.$emit( 'input', this.Selected?.replace( '-', '' ) );
            }
            else if ( x && Lib.Email( x ) ) {
                this.Error = false;
                this.selected = x;
                this.$emit( 'input', this.Selected?.replace( '-', '' ) );
            } else  {
                this.Error = true;
            }

        }

        public async onLostFocus( event: any ) {

        }
    }
